module.exports = "https://img1.huilianyi.com/0/proxy-info.0f6430b2c5.appcore.png";